import { useEffect, useState } from 'react';
import { api, ApiError } from '../lib/api';
import { useToast } from '../context/ToastContext';
import type { Client } from './Clients';

export function Users() {
  const toast = useToast();
  const [clients, setClients] = useState<Client[]>([]);
  const [id, setId] = useState('');
  const [name, setName] = useState('');
  const [role, setRole] = useState('admin');
  const [clientId, setClientId] = useState('');
  const [pin, setPin] = useState('');
  const [msg, setMsg] = useState<{ text: string; err: boolean } | null>(null);

  useEffect(() => { api<Client[]>('/v1/clients').then(setClients).catch(() => {}); }, []);

  const needsClient = role === 'client_owner' || role === 'driver';

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!id.trim() || !name.trim() || !pin.trim()) { setMsg({ text: 'Identifiant, nom et PIN sont obligatoires.', err: true }); return; }
    const body: Record<string, unknown> = { user_id: id.trim(), name: name.trim(), role, pin: pin.trim() };
    if (needsClient && clientId) body.client_id = clientId;
    try {
      await api('/v1/users', { method: 'POST', body });
      setMsg({ text: 'Utilisateur créé.', err: false });
      toast('Utilisateur créé');
      setId(''); setName(''); setPin('');
    } catch (e) { setMsg({ text: e instanceof ApiError ? e.message : 'Erreur', err: true }); }
  }

  return (
    <>
      <div className="pagehead"><h1>Utilisateurs</h1></div>
      <div className="card">
        <h2>Créer un utilisateur</h2>
        <p className="muted">Il n'existe pas de liste des utilisateurs côté API — seule la création est possible ici.</p>
        <form onSubmit={submit}>
          <label>Identifiant</label><input value={id} onChange={(e) => setId(e.target.value)} placeholder="ex. magasinier1" />
          <label>Nom</label><input value={name} onChange={(e) => setName(e.target.value)} />
          <label>Rôle</label>
          <select value={role} onChange={(e) => setRole(e.target.value)}>
            <option value="admin">admin</option>
            <option value="manager">manager</option>
            <option value="storekeeper">storekeeper (magasinier)</option>
            <option value="driver">driver (chauffeur)</option>
            <option value="hygiene_officer">hygiene_officer (agent lavage)</option>
            <option value="client_owner">client_owner (patron client)</option>
          </select>
          {needsClient && (
            <>
              <label>Client lié</label>
              <select value={clientId} onChange={(e) => setClientId(e.target.value)}>
                <option value="">—</option>
                {clients.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </>
          )}
          <label>Code PIN (4 à 8 chiffres)</label>
          <input type="password" inputMode="numeric" value={pin} onChange={(e) => setPin(e.target.value)} />
          <div className="row" style={{ marginTop: '0.8rem' }}><button type="submit" className="primary">Créer l'utilisateur</button></div>
          {msg && <div className={msg.err ? 'err' : 'ok'}>{msg.text}</div>}
        </form>
      </div>
    </>
  );
}
